<ng-container *ngIf="upgradeOffer$ | async as upgradeOffer">
  <div
    *ngIf="(status$ | async) === UpgradeStatus.LOADING"
    class="rounded-large white-text align-center font-heading-3 pr-small mr-small-t"
    [ngStyle]="{ 'background-color': upgradeOffer.upgradeFareFamily.brandColor }"
  >
    <div class="mr-xsmall-t">
      <fcom-loader [loaderType]="LoaderTheme.INLINE" [color]="LoaderColor.WHITE"></fcom-loader>
    </div>
  </div>
  <div *ngIf="(status$ | async) === UpgradeStatus.READY" data-testid="upgrade-promotion-content">
    <h2 class="font-body-1 bold-type mr-xsmall-y">{{ 'ticketUpgradePromotion.header' | finLocalization }}</h2>
    <div class="ms-small-t flex white-text column-small">
      <div
        class="upsell-current ps-small flex flex--space-between relative"
        [ngStyle]="{ 'background-color': upgradeOffer.currentFareFamily.brandColor }"
      >
        <div class="column-small flex flex--space-between">
          <div class="flex flex--column">
            <span class="font-body-2">{{ 'ticketUpgradePromotion.currentSelection' | finLocalization }}</span>
            <span class="font-body-1 medium-type">{{ upgradeOffer.currentFareFamily.brandName }}</span>
          </div>
          <span class="upsell-price font-body-1 bold-type">{{ currentTotalPrice$ | async | finPrice }}</span>
        </div>
        <span class="font-body-2">
          <fcom-icon class="ms-xsmall-r" [name]="SvgLibraryIcon.MMB_TICKET_CHANGES"></fcom-icon>
          <button
            class="white-text underline"
            *ngIf="selectedBenefitKey$ | async as key"
            (click)="openFareFamilyModal($event)"
          >
            {{ 'ticketUpgradePromotion.benefits.selected.' + key | finLocalization }}
          </button>
        </span>
        <div class="upsell-arrow" [ngStyle]="{ color: upgradeOffer.currentFareFamily.brandColor }">
          <svg class="grow dn-laptop-down" viewBox="0 0 15 101" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.32007 0L12.0001 50.5L4.32007 101H6.68007L15.0001 50.5L6.68007 0H4.32007Z" fill="white" />
            <path d="M12.0001 50.5L4.32007 0H0V101H4.32007L12.0001 50.5Z" fill="currentColor" />
          </svg>
          <svg class="dn-laptop-up" viewBox="0 0 288 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M288 9.08139V7.08139L145.694 16.5L0 7.08139V9.08139L145.694 18.5L288 9.08139Z" fill="white" />
            <path d="M288 0V7.08139L145.694 16.5L0 7.08139V0H288Z" fill="currentColor" />
          </svg>
        </div>
      </div>
      <div
        class="upsell-comparison ps-small-b ps-small-r flex flex--space-between"
        [ngStyle]="{ 'background-color': upgradeOffer.upgradeFareFamily.brandColor }"
      >
        <div class="column-small flex flex--space-between">
          <div class="flex flex--column">
            <span class="font-body-2">{{ 'ticketUpgradePromotion.updateTo' | finLocalization }}</span>
            <span class="font-body-1 medium-type">{{ upgradeOffer.upgradeFareFamily.brandName }}</span>
          </div>
          <div class="flex" *ngIf="upgradePriceDiffTrend$ | async as upgradePriceDiffTrend">
            <span
              class="upsell-price font-body-1 bold-type"
              *ngIf="upgradePriceDifference$ | async as upgradePriceDifference"
            >
              {{ upgradePriceDiffTrend ? '+' : '-' }}
              {{ upgradePriceDifference | finPrice | finEmpty: '&ndash;' }}
            </span>
          </div>
        </div>
        <div class="column-small flex flex--space-between flex--align-end">
          <span class="font-body-2">
            <fcom-icon class="ms-xsmall-r" [name]="SvgLibraryIcon.MMB_TICKET_CHANGES"></fcom-icon>
            <button
              class="white-text underline"
              *ngIf="suggestedBenefitKey$ | async as key"
              (click)="openFareFamilyModal($event)"
            >
              {{ 'ticketUpgradePromotion.benefits.suggested.' + key | finLocalization }}
            </button>
          </span>
          <fcom-button
            class="ms-xsmall-l ms-xsmall-t"
            [text]="'ticketUpgradePromotion.button' | finLocalization"
            [size]="ButtonSize.MEDIUM"
            [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
            (clickBtn)="openUpgradeModal($event)"
          ></fcom-button>
        </div>
      </div>
    </div>
  </div>
  <div
    *ngIf="(status$ | async) === UpgradeStatus.IN_PROGRESS"
    class="rounded-large white-text align-center font-heading-3 pr-small mr-small-t"
    [ngStyle]="{ 'background-color': upgradeOffer.upgradeFareFamily.brandColor }"
  >
    {{ 'ticketUpgradePromotion.updating' | finLocalization }}
    <div class="mr-xsmall-t">
      <fcom-loader [loaderType]="LoaderTheme.INLINE" [color]="LoaderColor.WHITE"></fcom-loader>
    </div>
  </div>
  <div
    *ngIf="(status$ | async) === UpgradeStatus.DONE"
    class="flex rounded-large white-text font-body-1 pr-small mr-small-t"
    [ngStyle]="{ 'background-color': upgradeOffer.upgradeFareFamily.brandColor }"
  >
    <fcom-icon [name]="SvgLibraryIcon.CHECKMARK_OUTLINE"></fcom-icon>
    <div class="flex-1 pr-small-l">
      <div>
        {{ 'ticketUpgradePromotion.done' | finLocalization }}
        {{ upgradeOffer.upgradeFareFamily.brandName }}
      </div>
      <div class="pr-xsmall-t">
        <a href="#" class="font-body-1 light-type white-text" (click)="openFareFamilyModal($event)">
          {{ 'ticketUpgradePromotion.viewDetails' | finLocalization }}
        </a>
      </div>
    </div>
    <div>
      <fcom-icon-button
        [icon]="{ name: SvgLibraryIcon.CLOSE_DELETE }"
        [theme]="IconButtonTheme.DARK_TERTIARY_GHOST"
        [size]="IconButtonSize.MEDIUM"
        [aria]="{ label: 'actions.close' | finLocalization }"
        (clickBtn)="hide()"
      >
      </fcom-icon-button>
    </div>
  </div>
  <fcom-modal
    class="benefits-modal"
    [title]="'fareFamilyDetails.title' | finLocalization"
    [buttons]="ModalButtons.DONE"
    [open]="fareFamilyModalOpen"
    (close)="closeModals()"
  >
    <fin-fare-family-details
      class="block pr-medium"
      [fareFamilies]="[upgradeOffer.currentFareFamily, upgradeOffer.upgradeFareFamily]"
    >
    </fin-fare-family-details>
  </fcom-modal>
</ng-container>

<fcom-modal
  [title]="'ticketUpgradePromotion.modal.title' | finLocalization"
  [buttons]="ModalButtons.CUSTOM"
  [(open)]="upgradeModalOpen"
>
  <fin-upgrade-promotion-modal [cart$]="cartData$" [upgradeOffer$]="upgradeOffer$"></fin-upgrade-promotion-modal>
  <div buttons>
    <fcom-button
      class="mr-xsmall-r"
      [text]="'actions.back' | finLocalization"
      [theme]="ButtonTheme.LIGHT_SECONDARY_OUTLINE"
      [aria]="{ label: 'actions.back' | finLocalization, role: 'button' }"
      (clickBtn)="upgradeModalOpen = false"
    ></fcom-button>
    <fcom-button
      [text]="'actions.confirm' | finLocalization"
      [aria]="{ label: 'actions.confirm' | finLocalization, role: 'button' }"
      (clickBtn)="confirmUpgrade()"
    ></fcom-button>
  </div>
</fcom-modal>
